<form [formGroup]="profileMinor" (ngSubmit)="updateMinor({toEnable:true})">
    <div class="container-fluid">
        <div class="row text-center m-2" *ngIf="((this.minorService.toBeDeleted$  | async)?.deleted && (this.minorService.toBeDeleted$  | async)?.uid === uid) || (isDeleted == 'tobedeleted')"><span class="deletedUser">{{this.email}}:</span><span class="deletedUser" [innerHTML]="('label.alertMessageDelete' | translation)"></span></div>
        <div class="row text-center m-2" *ngIf="((this.minorService.toBeDeleted$  | async)?.disabled && (this.minorService.toBeDeleted$  | async)?.uid === uid) || (isMinorPlus && isDeleted == 'disabled')"><span class="deletedUser">{{this.email}}:</span><span class="deletedUser" [innerHTML]="('label.alertMessageDisable' | translation)"></span></div>
        <div class="row">
            <mat-grid-list cols="4" rowHeight="100px">
                <mat-grid-tile *ngFor="let tile of profile" [colspan]="tile.cols" [rowspan]="tile.rows"
                    [style.background]="tile.color">
                    <app-form-fields [form]="this.profileMinor" [control]="tile.name" [isMinorPlus]="isMinorPlus"[min]="tile.min||0" [max]="tile.max||0" [value]="tile.value" [label]="tile.label"
                        [type]="tile.type" [options]="tile.options||[]" [required]="this.isMinor && tile.name!='profile.gender'"></app-form-fields>
                </mat-grid-tile>
            </mat-grid-list>
        </div>
        <div class="row">
            <div class="modifyLabel d-flex justify-content-start"> <span
                    [innerHTML]="('label.edit_contact_address_label' | translation)"></span>
                <a href="mailto:#" [innerHTML]="('label.edit_contact_address' | translation)"> -default-</a>
            </div>
        </div>
        <div class="row text-center mt-2">
            <h2 [innerHTML]="('label.initiativesTitle' | translation)"></h2>
        </div>
        <div class="row text-start mt-1">
            <h3 [innerHTML]="('label.initiativesInfo' | translation)"></h3>
        </div>
        <div class="row">
            <div class="container-fluid" *ngFor="let init of distinctInitiatives">
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{init.name}}
                        </mat-panel-title>
                        <mat-panel-description class="text-end" *ngIf="!init.status">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path
                                    d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                            </svg><span class="m-1" [innerHTML]="('label.missingConsents' | translation)">... </span>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="row" *ngIf="this.allInitiativesTeams.length>0">
                        <ng-container *ngFor="let tms of this.allInitiativesTeams">
                            <app-form-fields *ngIf="tms.id == init.id" [form]="this.profileMinor" [control]="'data.favouriteSoccerTeam_'+init.id" [label]="'field.label.favouriteSoccerTeam.favourite'"
                                [type]="'select'" [options]="[]" [initiativeId]="init.id"></app-form-fields>
                        </ng-container>
                        
                    </div>
                    <div class="container-fluid" *ngFor="let opt of optin; let i=index ">
                        <ng-container *ngIf="opt.initiativeName === init.name">
    
                            <div class="row"><app-form-fields [form]="this.profileMinor" [control]="opt.optinName" [value]="opt.status"  [type]="'checkbox'"
                                    [description]="opt.optinName" [required]="true"></app-form-fields>
                            </div>
                        </ng-container>
                    </div>
                    <div class="container-fluid" *ngFor="let cnt of consents; let i=index">
                        <ng-container *ngIf="cnt.initiativeName === init.name">
    
                            <div class="row">
                                <app-form-fields [form]="this.profileMinor" [value]="cnt.status"  [control]="cnt.fieldName" [type]="'checkbox'"
                                    [description]="'field.label.'+cnt.fieldName.split('.')[1]+'.parte1'"
                                    [linkPrivacyTos]="'field.label.'+cnt.fieldName.split('.')[1]+'.parte2'"
                                    [required]="true">
                                </app-form-fields>
                            </div>
                        </ng-container>
                    </div>
    
                </mat-expansion-panel>
            </div>
    
        </div>
        <div class="container-fluid m-2">
            <div class="row d-flex justify-content-center text-start mt-5 mb-5" *ngIf="!this.isActive">
                <button type="submit" class="btn btn-primary buttonsMinor" [innerHTML]="('button.enableProfile'|translation)"></button>
            </div>
            <div class="row d-flex justify-content-center text-start mt-5 mb-5" *ngIf="this.isActive">
                <button type="button" *ngIf="isMinor" class="btn m-2 btn-primary buttonsMinor" [innerHTML]="('button.downloaddata'|translation)" (click)="downloadData()"></button>
                <button type="button" *ngIf="isMinorPlus" class="btn m-2 btn-primary buttonsMinor" [innerHTML]="'Disable'" (click)="deleteMinorOrDisbaleMinPlus()"></button>
                <button type="button" *ngIf="isMinor" class="btn m-2 btn-primary buttonsMinor" [innerHTML]="('button.deleteaccount'|translation)" (click)="deleteMinorOrDisbaleMinPlus()"></button>
                <button type="button" *ngIf="isMinor || (isMinorPlus && this.distinctInitiatives.length != this.initTrue.length)" class="btn m-2 btn-primary buttonsMinor" [innerHTML]="('button.updateprofile'|translation)" (click)="updateMinor({toEnable:false})"></button>
                
            </div>
        </div>
    
    </div>
</form>

